export default __webpack_public_path__ + "static/media/lemontbotanique_background_m2.a37cff98.jpg";